import React, { useState, useEffect } from "react";

export default function Leader(props) {
  const [state, setState] = useState(null);

  return <div>Leader</div>;
}
